import script from "./LastPageModal.vue?vue&type=script&setup=true&lang=js"
export * from "./LastPageModal.vue?vue&type=script&setup=true&lang=js"

import "./LastPageModal.vue?vue&type=style&index=0&id=32ad5575&scoped=true&lang=css"

import exportComponent from "/builds/sense/sense-signer/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32ad5575"]])

export default __exports__